import firebase from 'firebase';
import { useAtom } from 'jotai';
import { userAtom, userRecordAtom } from '../state/atoms';
import { auth, db } from './firebase';

function useAuthService() {
  const [, setUser] = useAtom(userAtom);
  const [, setUserRecord] = useAtom(userRecordAtom);

  const createUserWithEmailAndPassword = (email, password) =>
    auth()
      .createUserWithEmailAndPassword(email, password)
      .catch((err) => {
        console.error('Reg error: ', err);
      });

  const signIn = (email, password) =>
    auth()
      .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(() =>
        firebase
          .auth()
          .signInWithEmailAndPassword(email, password)
          .then((res) => res)
      );

  const resetPassword = (email) =>
    auth()
      .sendPasswordResetEmail(email)
      .then((res) => res);

      const signOut = async () => {
        const user = auth().currentUser;
        if (user) {
          const studentRef = db.collection("Students").doc(user.uid);
          const studentDoc = await studentRef.get();
      
          if (studentDoc.exists) {
            await studentRef.update({
              SessionToken: null,
            });
          }
        }
      
        localStorage.removeItem("SessionToken");
        setUser(null);
        setUserRecord(null);
        await auth().signOut();
      };

  return {
    createUserWithEmailAndPassword,
    signIn,
    resetPassword,
    signOut,
  };
}

export default useAuthService;
